import Dialog from '../../../../organisms/Dialog';
import { DeadLetterQueue } from '../../../../../services/eventingApi';
import { buttonClass } from '../shared/ui';

interface RedriveDialogProps {
  queue: DeadLetterQueue | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (queue: DeadLetterQueue) => void;
}

const RedriveDialog = ({ queue, submitting, onClose, onConfirm }: RedriveDialogProps) => (
  <Dialog
    id="event-platform-redrive"
    show={Boolean(queue)}
    onClose={onClose}
    header="Devolver a DLQ para a fila"
    body={
      <p className="text-sm dark:text-gray-200">
        As {queue?.messages} mensagem(ns) de <code>{queue?.deadLetterQueueName}</code> voltam para <code>{queue?.queueName}</code> e o consumidor{' '}
        <code>{queue?.consumer}</code> tenta de novo. Confirme que a causa da falha foi corrigida.
      </p>
    }
    footer={
      <div className="flex justify-end gap-2">
        <button type="button" className={buttonClass.cancel} onClick={onClose}>
          Cancelar
        </button>
        <button type="button" className={buttonClass.destructive} disabled={submitting} onClick={() => queue && onConfirm(queue)}>
          {submitting ? 'Iniciando…' : 'Devolver'}
        </button>
      </div>
    }
  />
);

export default RedriveDialog;
